// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"848":"9a3db799","916":"79322de2"}[chunkId] + ".js";
};